import React from 'react';
import { formatRole } from '../../../helpers/FormatHelper';
import { User } from '../../../models/User';
import {useTranslation} from "react-i18next";
import {useLongPress} from "../../../hooks";

interface UsersProps {
    user: User;
    onClick: () => void;
    onContextMenu?: (anchorX: number, anchorY: number) => void;
}


const UsersShort: React.FC<UsersProps> = ({user, onClick, onContextMenu} : UsersProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event: React.MouseEvent<HTMLTableRowElement>) => {
        if (!onContextMenu) {
            return;
        }
        event.preventDefault();
        onContextMenu(event.clientX, event.clientY);
    };
    // touch: long press opens the context menu (iOS does not fire contextmenu)
    const longPress = useLongPress(onContextMenu);
    return (
        <tr onClick={onClick} onContextMenu={onContextMenu ? contextMenuHandler : undefined} {...longPress}>
            <td>{user.name}</td>
            <td width="1" align="center">{user.email}</td>
            <td width="1" align="center">{formatRole(t, user.role)}</td>
        </tr>
        );
}

export default UsersShort;